import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/people/$siteId/lists/$listId")({
  component: () => {
    return <Outlet />;
  },
});
